import GallectionDeviationSelector from './GallectionDeviationSelector';
export default GallectionDeviationSelector;
